<template lang="pug" src="./block-vue-trigger.pug"></template>

<script>
export default {
  props: {
    content: {
      Type: Object,
      default: () => {}
    },
    function1: {
      Type: Function,
      default: function googleIt () {
        this.$store.dispatch('VIEW_DEFAULT', false)
      }
    },
    function2: {
      Type: Function,
      default: function googleIt () {
        this.$store.dispatch('VIEW_DEFAULT', false)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// block-vue-trigger.vue?10445df0